// extracted by mini-css-extract-plugin
module.exports = {"UserImage":"UserProfile_UserImage__2Nopd"};